<script setup>
import { ref } from 'vue';

const loggedIn = ref(false);
const error = ref(false);
const pass = ref('');

// eslint-disable-next-line
function isUserLoggedIn() {
  console.log('Is user logged in?');

  // Check to see if the user is logged in
  let user = sessionStorage.getItem('user');
  if (user) {
    // Hide the password disclaimer, show the protected content
    loggedIn.value = true;
  }
}

function login() {
  // Does the entered value match our super secret hidden password?
  if (pass.value === 'Hello!' || pass.value === 'lightbulb') {
    // Store the username
    sessionStorage.setItem('user', 'guest');

    // Close the disclaimer, show the content
    loggedIn.value = true;
  } else {
    // Show the error
    error.value = true;
  }
}

isUserLoggedIn();
</script>

<template>
  <div class="c-disclaimer">
    <h3>Disclaimer</h3>
    <p>
      <slot name="disclaimer" />
    </p>
    <p v-if="!loggedIn">
      For detailed case studies, or the password,
      <a href="https://www.linkedin.com/in/michaelcohnmoreau/" target="_blank"> please contact me</a>. Thank you.
    </p>

    <div class="c-disclaimer__passwordbox" v-if="!loggedIn">
      <label for="Password">Password:</label>
      <input type="password" v-model="pass" @keyup.enter="login" />
      <button @click="login">View</button>
      <div class="c-error" v-if="error">Oops, that wasn't right. Please try again.</div>
    </div>
  </div>

  <slot name="intro"> Introduction </slot>
  <slot name="protected" v-if="loggedIn"> CLASSIFIED </slot>
</template>

<style lang="scss" scoped>
.c-disclaimer {
  margin: 0 auto;
  margin-bottom: 40px;
  border-bottom: 1px solid #a01e3c;

  .c-disclaimer__passwordbox {
    text-align: center;
    padding: 20px 0;
  }

  h3 {
    color: #a01e3c;
    text-align: left;
    padding-top: 0;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #a01e3c;
  }

  h3,
  p {
    text-align: left;
  }

  label {
    padding-bottom: 0.5rem;
    padding-right: 0.5rem;
    font-weight: bold;
  }

  input {
    margin-right: 1rem;
    line-height: 2rem;
  }

  .c-error {
    margin-top: 0.5rem;
    color: red;

    a {
      border-bottom: 1px solid red;
    }
  }
}
</style>
